import * as moment from 'moment'

import { createdAtIntervalOptions } from '@/redux/incidents/incidentsFilterOptions'

// UTC boundaries of a custom date-range filter value. Defined here (not in a
// component library) so both the Chakra V1 tree and the dark tree can share it
// without importing a rendering barrel; @/components/ui re-exports it for
// legacy consumers.
export interface DateValueI {
  gte: string
  lte: string
}

type LabelValues = {
  value: unknown
  label: string
}

export interface LabelValueIProps {
  label: string
  value: string
}

export const hours24 = moment.utc().subtract(24, 'hours').format()
export const last2Days = moment.utc().subtract(2, 'days').format()
export const last7Days = moment.utc().subtract(7, 'days').format()
export const last30Days = moment.utc().subtract(30, 'days').format()

export const createdAtOptions = [
  {
    value: {
      gte: hours24,
    },
    label: 'Last 24 hours',
  },
  {
    value: {
      gte: last2Days,
    },
    label: 'Last 2 Days',
  },
  {
    value: {
      gte: last7Days,
    },
    label: 'Last 7 Days',
  },
  {
    value: {
      gte: last30Days,
    },
    label: 'Last 30 Days',
  },
]

// Does the same thing but with clearer names targetting submission times
export const submittedAtIntervalOptions = createdAtIntervalOptions

export const activeIncidentsOptions = [
  { value: true, label: 'Has Active Incidents' },
  { value: false, label: 'Does Not Have Active Incidents' },
]

export const getRelatedFloors = (
  facilities: LabelValues[],
  floors: LabelValues[]
) => {
  return floors?.filter((flr) =>
    facilities?.some((fac) => {
      const facility = fac.label
      const floorFacility = flr.label.substring(
        flr.label.indexOf('(') + 1,
        flr.label.indexOf(')')
      )
      return facility.includes(floorFacility)
    })
  )
}

export const getUniqueValues = (items: LabelValueIProps[]) =>
  [...new Map(items.map((i) => [i.value, i])).values()].filter((e) => e.value)

export interface FilterOptionI<T = string> {
  label: string
  value: T
  color?: string
  /** Secondary line under the label (e.g. a facility's short name + address). */
  subtitle?: string
  /** Tertiary, italicized line under the subtitle (e.g. a "matched by X" cue). */
  caption?: string
}

export const isCustomDateRange = (
  dateFilter: FilterOptionI<number | DateValueI>
) => {
  // Check if the value is a number
  const dateAsNumber = Number(dateFilter?.value)
  return isNaN(dateAsNumber)
}
